<template>
  <div class="DepositoDentalListado">
    <v-card
      outlined
      :disabled="cargando"
      :loading="cargando"
    >
      <v-card-title>
        Depósito dental
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar"
          hide-details
        />
        <deposito-dental-form-dialog
          @msg="$emit('msg',$event)"
          @httpError="$emit('httpError',$event)"
          @refresh="_getDepositos"
          v-model="idDep"
        />
      </v-card-title>
      <v-data-table
        class="upper"
        :headers="headers"
        :items="depositos"
        :search="search"
        :loading="cargando"
        loading-text="Cargando..."
      >
        <template v-slot:item.precio_dep="{ item }">
          {{$nF(item.precio_dep)}}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon v-text="'more_vert'" />
              </v-btn>
            </template>
            <v-list dark>
              <v-list-item @click="idDep=item.id">
                <v-list-item-title v-text="'Editar'" />
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import standard from "@/mixins/standard.js";
import forms from "@/mixins/forms.js";
import DepositoDentalFormDialog from "@/components/depositodental/DepositoDentalFormDialog.vue";
export default {
  name: "DepositoDentalListado",
  mixins: [standard, forms],
  components: {
    DepositoDentalFormDialog,
  },
  methods: {
    _getDepositos() {
      this.idDep = null;
      this._getThings("depositodental/materiales", "depositos");
    },
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Nombre", value: "nombre_dep" },
        { text: "Categoría", value: "nombre_dca" },
        { text: "Precio", value: "precio_dep", align: "end" },
        { text: "Descripción", value: "descripcion_dca" },
        { text: "", value: "actions", align: "end" },
      ],
      depositos: [],
      idDep: null,
    };
  },
  created() {
    this._getDepositos();
  },
};
</script>